import Button from "../buttons/Button";
import { useDispatch } from "react-redux";
import { closeBackdrop } from "../../../slice/sellerHub/sellerhubSlice";
import useAuth from "../../../hooks/useAuth";
import TransactionIndividualTable from "./TransactionIndividualTable";

const TransactionIndividual = () => {
  const { transactionIndividual } = useAuth();
  const dispatch = useDispatch();
  return (
    <div className="w-full md:w-[500px] lg:w-[806px] h-full bg-white p-5">
      <div className="flex gap-5 md:gap-0 justify-between flex-col md:flex-row items-start md:items-center">
        <h4>Reference ID: {transactionIndividual[0].referenceId}</h4>
        <div className="w-full md:w-auto flex justify-end md:justify-start gap-10 items-center">
          <div
            className="w-fit text-logoRed font-Inter font-medium cursor-pointer"
            onClick={() => dispatch(closeBackdrop())}
          >
            Close
          </div>
          <Button
            innerText="Download"
            width="w-[133px]"
            icon={[
              <svg
                key={Math.random()}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-file-earmark-minus"
                viewBox="0 0 16 16"
              >
                <path d="M5.5 9a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z" />
                <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
              </svg>,
            ]}
          />
        </div>
      </div>

      <div className="pl-5 pr-5 pb-5 text-base font-Inter font-medium flex justify-between border-[0.5px] border-[#E9EAEC] rounded  mt-10">
        <div className="md:w-1/2">
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Reference ID
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Date
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Transaction Type
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Amount
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Status
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            12/07/2022 3:34pm
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            12/07/2022 3:34pm
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            12/07/2022 3:34pm
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            12/07/2022 3:34pm
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            12/07/2022 3:34pm
          </div>
        </div>
        <div className="md:w-1/2">
          {transactionIndividual.map((data) => (
            <TransactionIndividualTable data={data} key={Math.random()} />
          ))}
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Pending
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Pickup ready
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Picked up
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            In transit
          </div>
          <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
            Delivered
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionIndividual;
